import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Header from "../components/Header.jsx";
import Footer from "../components/Footer.jsx";
import SGOfficeAssistant from "../components/Sgofficeassistant.jsx";
import FloatingContactButtons from "../components/FloatingContactButtons.jsx";

const PublicLayout = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <Outlet />
      <SGOfficeAssistant onNavigate={(path) => navigate(path)} />
      <FloatingContactButtons />
      <Footer />
    </>
  );
};

export default PublicLayout;
